export type NotifiersType = {
  id: string;
  data: { description: string; title: string } | null;
  active: boolean;
  loading: boolean;
  query: Query;
  others: Others;
};

export const initialState: NotifiersType = {
  id: "",
  active: false,
  data: null,
  loading: false,
  query: {
    arrival_id: "",
    departure_id: "",
    outbound_date: "",
    return_date: "",
  },
  others: {
    adults: 0,
    children: 0,
    trip: "",
  },
};

export type Query = {
  departure_id: string;
  arrival_id: string;
  outbound_date: string;
  return_date: string;
};

export type Others = {
  trip: string;
  adults: number;
  children: number;
};
